// Skeleton UI
import 'vue-skeletor/dist/vue-skeletor.css';
import { Skeletor } from 'vue-skeletor';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import i18n from './i18n';
import config from './config';
import App from './App.vue';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp({
  render: () => (App),
});

// Setup skeleton loader
app.component(Skeletor.name, Skeletor);

createApp(App).use(router).use(i18n).use(pinia)
  .mount('#calmac-app');

if (window.location.hash.length <= 2 && config && config.route) {
  router.push(config.route);
}
